import { useQuery } from '@ts-core/lib/apollo';
import { DataFetcherHookResult } from '@ts-core/core/types';

import { StudentAssignmentsActivity } from '@ts-core/modules/billing/types';
import {
  getStudentAssignmentsByMonthQuery,
  GetStudentAssignmentsByMonthQueryResult,
  GetStudentAssignmentsByMonthQueryVariables,
} from '../graphql/queries/getStudentAssignmentsByMonthQuery';

export type StudentAssignmentsByMonthHookResult = DataFetcherHookResult<StudentAssignmentsActivity[], 'assignments'>;

export interface StudentAssignmentsByMonthHookInput {
  courseId: string;
  studentId: string;
  year: string;
  month: string;
}

export function useStudentAssignmentsByMonth(input: StudentAssignmentsByMonthHookInput): StudentAssignmentsByMonthHookResult {
  const { courseId, studentId, year, month } = input;
  const { data, loading, errorMessage } = useQuery<GetStudentAssignmentsByMonthQueryResult, GetStudentAssignmentsByMonthQueryVariables>(
    getStudentAssignmentsByMonthQuery,
    { variables: { courseId, studentId, year, month } }
  );

  return { loading, error: errorMessage, assignments: data?.assignments };
}
